import { render, staticRenderFns } from "./GraphDetail47.vue?vue&type=template&id=3ab85985&scoped=true"
import script from "./GraphDetail47.vue?vue&type=script&lang=js"
export * from "./GraphDetail47.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab85985",
  null
  
)

export default component.exports